import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Avatar, Paper, Typography } from '@mui/material'

import { Box } from '@/components/ui'
import type { Organization } from '@/definitions/organization'
import { formatDisplayDate } from '@/utils/dateUtils'

interface OrgCardProps {
  org: Organization
  onClick: () => void
}

export const OrgCard = ({ org, onClick }: OrgCardProps) => {
  const formattedDate = formatDisplayDate(org.created_time)

  return (
    <Paper
      variant='orgCard'
      onClick={onClick}
      tabIndex={0}
      role='button'
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <Box variant='flexBetween'>
        <Box variant='flex' gap='md'>
          <Avatar variant='orgCard'>
            {org.display_name.charAt(0)}
          </Avatar>
          <Box variant='flexColumn' gap='xs' fullWidth={false}>
            <Typography variant='subtitle1' className='OrgCard-name'>
              {org.display_name}
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {org.domain_name}
            </Typography>
          </Box>
        </Box>

        <Box variant='flex' gap='lg'>
          <Box>
            <Typography variant='overline' color='text.secondary' align='center'>
              Created
            </Typography>
            <Typography variant='body2' fontWeight={500} align='center'>
              {formattedDate}
            </Typography>
          </Box>
          <ChevronRightIcon />
        </Box>
      </Box>
    </Paper>
  )
}
